import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { GetReviewSurveysPayload } from 'ha/services/apiV2/types/ReviewSurvey';
import { ReviewSurveysRequest } from 'ha/services/apiV2/types/ReviewSurveys';
import { APIV2_URL } from './constants';

export default (makeCall: MakeCall) => (query: ReviewSurveysRequest) =>
  makeCall<GetReviewSurveysPayload>('GET', `${APIV2_URL}/review/surveys`, {
    query,
  });
